<!-- This file is generated by @sveltejs/kit — do not edit it! -->
<svelte:options runes={true} />
<script>
	import { afterNavigate } from '$app/navigation';

	let { page, constructors, components = [], form, data_0 = null, data_1 = null } = $props();
	

	let mounted = $state(false);
	let navigated = $state(false);
	let title = $state(null);

	afterNavigate(() => {
		if (mounted) {
			navigated = true;
			title = document.title || 'untitled page';
		} else {
			mounted = true;
		}
	});

	const Pyramid_1 = $derived(constructors[1]);
</script>

{#if constructors[1]}
	{@const Pyramid_0 = constructors[0]}
	<!-- svelte-ignore binding_property_non_reactive -->
	<Pyramid_0 bind:this={components[0]} data={data_0} {form} params={page.params}>
		<!-- svelte-ignore binding_property_non_reactive -->
		<Pyramid_1 bind:this={components[1]} data={data_1} {form} params={page.params} />
	</Pyramid_0>
{:else}
	{@const Pyramid_0 = constructors[0]}
	<!-- svelte-ignore binding_property_non_reactive -->
	<Pyramid_0 bind:this={components[0]} data={data_0} {form} params={page.params} />
{/if}

{#if mounted}
	<div id="svelte-announcer" aria-live="assertive" aria-atomic="true" style="position: absolute; left: 0; top: 0; clip: rect(0 0 0 0); clip-path: inset(50%); overflow: hidden; white-space: nowrap; width: 1px; height: 1px">
		{#if navigated}
			{title}
		{/if}
	</div>
{/if}